import React, { useState, useRef, useEffect } from "react";
import { Link, useNavigate,useParams} from "react-router-dom";
import { Pagination, EffectFade, Autoplay } from "swiper/modules";

import { useTranslation } from "react-i18next";

import swal from 'sweetalert';

import ttsAudio from "../assets/sound/tts_04.mp3"; // mp3 경로 import


const About1 = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { name } = useParams();
    const { sex } = useParams();

    const audioRef = useRef(null);


    const [birth,SetBirth]=useState();

    const clickNext= () => {


        if(birth=="" || birth=="undefined"){
            swal(t('생년월일을 입력해주세요'),'',"error");
            return;
        }
        navigate('/about2/'+name+'/'+sex+'/'+birth);
    };

    // 컴포넌트 마운트 시 자동 재생
    useEffect(() => {
        const audio = audioRef.current;
        if (audio) {
            audio.play().catch(err => {
                console.warn("Autoplay failed:", err);
            });
        }
    }, []);

    return (
        <main className="main-container">

            <audio ref={audioRef} src={ttsAudio} autoPlay />
            
            <div className="input-area">
                <div className="step_area">
                    STEP 3
                </div>
                <div className="title_area">
                    <h1 className="num_title">(3/4)</h1>
                    <h2 className="title">생년월일을 입력해주세요</h2>
                </div>

                <div className="input_section">
                    <input
                        type="number"
                        className="text_nor md"
                        id="join_name"
                        autoComplete="off"
                        value={birth}
                        placeholder="예) 19990101"
                        onChange={e => {
                            SetBirth(e.target.value);
                        }}
                    />

                    <div className="start-btn-area">
                        <button className="Next" onClick={() => clickNext()}>확인</button>
                    </div>
                </div>
            </div>
        </main>
    );
};

export default About1;
